function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("react"), require("d3")) : "function" == typeof define && define.amd ? define(["react", "d3"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["tns-reports"] = e(require("react"), require("d3")) : t["tns-reports"] = e(t.react, t.d3);
}(self, function (t, e) {
  return function () {
    "use strict";

    var r = {
      990: function _(t) {
        t.exports = e;
      },
      156: function _(e) {
        e.exports = t;
      }
    },
        n = {};

    function a(t) {
      var e = n[t];
      if (void 0 !== e) return e.exports;
      var i = n[t] = {
        exports: {}
      };
      return r[t](i, i.exports, a), i.exports;
    }

    a.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return a.d(e, {
        a: e
      }), e;
    }, a.d = function (t, e) {
      for (var r in e) {
        a.o(e, r) && !a.o(t, r) && Object.defineProperty(t, r, {
          enumerable: !0,
          get: e[r]
        });
      }
    }, a.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, a.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    };
    var i = {};
    return function () {
      a.r(i), a.d(i, {
        TNSReports: function TNSReports() {
          return t;
        }
      });
      var t = {};
      a.r(t), a.d(t, {
        HorizontalBarChart: function HorizontalBarChart() {
          return s;
        }
      });
      var e = a(156),
          r = a.n(e),
          n = a(990);

      function o(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, (void 0, "symbol" == _typeof(a = function (t, e) {
            if ("object" != _typeof(t) || null === t) return t;
            var r = t[Symbol.toPrimitive];

            if (void 0 !== r) {
              var n = r.call(t, "string");
              if ("object" != _typeof(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }

            return String(t);
          }(n.key)) ? a : String(a)), n);
        }

        var a;
      }

      function l(t, e) {
        return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
          return t.__proto__ = e, t;
        }, l(t, e);
      }

      function c(t) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, c(t);
      }

      var s = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && l(t, e);
        }(f, t);
        var e,
            a,
            i,
            s,
            u = (i = f, s = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(i);

          if (s) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return function (t, e) {
            if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t);
          }(this, t);
        });

        function f(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, f), (e = u.call(this, t)).barThickness = t.barThickness || 70, e.width = 1e3, e.height = t.elementPercentages.length * e.barThickness, e.state = {
            margin: {
              top: 30,
              right: 30,
              bottom: 20,
              left: 200
            }
          }, e.transitionDuration = 0, 1 == e.props.enableAnimations && (e.transitionDuration = 1e3), e;
        }

        return e = f, (a = [{
          key: "componentDidMount",
          value: function value() {
            this.drawChart(), this.updateMarginToContainLabels();
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.drawChart();
          }
        }, {
          key: "displayablePercent",
          value: function value(t) {
            return t.percent > 2 ? 2 : t.sufficiency_level ? t.percent : 2 / 3;
          }
        }, {
          key: "updateMarginToContainLabels",
          value: function value() {
            var t = document.getElementsByClassName("bar-element-label")[0];

            if (t) {
              var e = this.state.margin,
                  r = t.getBBox().width - e.left;
              r > 0 && (e.left = e.left + r + 15, this.setState({
                margin: e
              }));
            }
          }
        }, {
          key: "drawChart",
          value: function value() {
            var t = this,
                e = this.props.elementPercentages,
                r = n.select(this.svg);
            r.selectAll("*").remove();
            var a = r.attr("viewBox", "0 0 ".concat(this.width + this.state.margin.left + this.state.margin.right, " ").concat(this.height + this.state.margin.top + this.state.margin.bottom)).attr("width", "100%").append("g").attr("transform", "translate(" + this.state.margin.left + "," + this.state.margin.top + ")"),
                i = n.scaleLinear().domain([0, 2]).range([0, this.width]),
                o = n.scaleBand().range([0, this.width]).domain(["Low", "Acceptable", "High"]);
            a.append("g").attr("class", "bar-x-label").call(n.axisTop(o).tickSize(0)).select(".domain").remove();
            var l = n.scaleBand().range([0, this.height]).domain(e.map(function (t) {
              return t.label;
            })).padding(.4);
            a.append("g").attr("class", "bar-element-label").call(n.axisLeft(l).tickSize(0).tickPadding(15)).select(".domain").remove(), a.append("path").attr("class", "background-line").attr("d", n.line()([[i(2 / 3), 0], [i(2 / 3), this.height]])), a.append("path").attr("class", "background-line").attr("d", n.line()([[i(1 + 1 / 3), 0], [i(1 + 1 / 3), this.height]])), a.selectAll("myRect").data(e).enter().append("rect").attr("x", i(0)).attr("y", function (t) {
              return l(t.label);
            }).attr("width", i(2)).attr("height", l.bandwidth()).attr("class", "background-bar");
            var c = a.selectAll("myRect").data(e).enter();
            c.append("rect").attr("x", i(0)).attr("y", function (t) {
              return l(t.label);
            }).attr("width", function (t) {
              return i(0);
            }).attr("height", l.bandwidth()).attr("class", function (t) {
              return "low" == t.sufficiency_level ? "bar horizontal-bar-fill-red" : "high" == t.sufficiency_level ? "bar horizontal-bar-fill-green" : "acceptable" == t.sufficiency_level ? "bar horizontal-bar-fill-blue" : "bar horizontal-bar-fill-gray";
            });

            var s = 10 * Math.round(this.barThickness / 7 / 10),
                u = function u(t) {
              return 10 * String(t.value).length;
            },
                f = n.max(e.map(function (t) {
              return u(t);
            })) + 2 * s,
                p = function p(e) {
              return Math.max(f, i(t.displayablePercent(e)));
            };

            c.append("text").attr("class", "bar-text").attr("x", function (t) {
              return p(t) - u(t) - s;
            }).attr("y", function (t) {
              return l(t.label) + l.bandwidth() / 2 + 5;
            }).text(function (t) {
              return t.value;
            }), c.append("text").attr("class", "bar-ran-test-text").attr("x", function (e) {
              return i(t.displayablePercent(e)) + 50;
            }).attr("y", function (t) {
              return l(t.label) + l.bandwidth() / 2 + 5;
            }).text(function (t) {
              return t.sufficiency_level ? "" : "(perform RAN test to determine ".concat(t.symbol, " availability)");
            }), a.selectAll("rect.bar").transition().duration(this.transitionDuration).attr("width", function (t) {
              return p(t);
            }).attr("height", l.bandwidth()).delay(function (t, e) {
              return 100 * e;
            });
          }
        }, {
          key: "render",
          value: function value() {
            var t = this;
            return r().createElement("svg", {
              ref: function ref(e) {
                return t.svg = e;
              }
            });
          }
        }]) && o(e.prototype, a), Object.defineProperty(e, "prototype", {
          writable: !1
        }), f;
      }(r().Component);

      "undefined" != typeof window ? window.TNSReports = t : console.warn("Unable to register React components for TNS Reports");
    }(), i;
  }();
});